export default __webpack_public_path__ + "static/media/view-grid.e94c5982.svg";